module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/wimoveis.6a77e395.svg";